import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { ReactComponent as Clipboard } from '../../../assets/images/tasks/Clipboard-Pink.svg';
import CustomCheckbox from '../../../components/global/CustomCheckbox.component';
import CustomButtonLoader from '../../../components/global/CustomButtonLoader.component';
import { openSnackBar } from '../../../redux/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import './ConsentCrf.styles.css';

const ConsentCrfContainer = ({ crfData, handleSaveConsentDetails, t, isSaveBtnLoading }) => {
    const dispatch = useDispatch();
    const [formVal, setFormVal] = React.useState(null);

    React.useEffect(() => {
        if(crfData && crfData?.consentDetailsDtoList?.length > 0) {
            setFormVal(crfData.consentDetailsDtoList);
        }
    }, [crfData]);

    const handleFieldChange = (index) => {
        setFormVal((prevState) => {
            const updatedFormVal = prevState.map((item, idx) => {
                if(idx === index) {
                    return {
                        ...item,
                        checked: !item.checked,
                        ...(item?.msg ? {msg: null} : {})
                    }
                }
                return item;
            });
            return updatedFormVal;
        });
    }
    
    const handleSaveCrfConsent = async () => {
        try {
            //Check if all mandatory consents are checked
            const allMandatoryChecked = formVal.every(item => {
                if(item.mandatory) {
                    return item.checked === true;
                }
                return true;
            });

            if(!allMandatoryChecked) {
                // Add error message for unchecked mandatory consents
                const updatedFormVal = formVal.map(item => {
                    if(item.mandatory && !item.checked) {
                        return {
                            ...item,
                            msg: "this_consent_is_mandatory"
                        }
                    }
                    return item;
                });
                setFormVal(updatedFormVal);
                
                dispatch(openSnackBar({
                    msg: t("accept_all_mandatory_consents_to_proceed"),
                    type: "error"
                }))
                return;
            }

            //Prepare payload
            const dataToSend = {
                title: crfData?.title,
                description: crfData?.description,
                langId: crfData?.langId,
                consentDetailsDtoList: formVal.map(item => ({
                    orderId: item.orderId,
                    mandatory: item.mandatory,
                    enable: item.enable,
                    consentMessage: item.consentMessage,
                    modified: item.modified,
                    id: item.id,
                    checked: item.checked,
                    checkedAndSubmittedConsentIds: item.checkedAndSubmittedConsentIds,
                    unCheckedAndSubmittedConsentIds: item.unCheckedAndSubmittedConsentIds,
                    deleteDisable: item.deleteDisable,
                    mandatoryChange: item.mandatoryChange
                }))
            }

            //API call to save consent details
            handleSaveConsentDetails(dataToSend);
        
        } catch (error) {
            console.log("Error in saving consent details: ", error);
        }
    }

    return(
        <div className='bg-blue-gray-50 cm-crf-container-wrapper py-5'>
            <div className="cm-crf-inner-wrapper bg-white p-5">
                <h4 className='mb-4 pb-4 border-bottom border-blue-gray-200 text-blue-800 d-flex align-items-start cm-crf-heading-wrapper text-break'><Clipboard /> <span className='ps-2'>{crfData?.title}</span></h4>
                <p className='cm-sm-txt text-blue-gray-700 mb-32 text-break'>{crfData.description}</p>
                {
                    formVal && formVal.length > 0 ? formVal.map((item, index) => (
                        <div key={index} className='mb-4 d-flex align-items-start'>
                            <div className='mt-1'>
                                <CustomCheckbox
                                    isChecked={item.checked}
                                    handleCheckboxChange={(e) => handleFieldChange(index)}
                                    checkboxId={"mandatory-checkbox-" + index}
                                />
                            </div>
                            <div className='ps-10'>
                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.consentMessage) }} className='cm-gen-styles text-blue-800'></div>
                                {item.msg && <span className='text-danger text-break cm-xs-txt fw-medium pt-2 d-inline-block'>{t(item.msg)}</span>}
                            </div>
                        </div>
                    )) : <div>{t("no_consent_details_available")}</div>
                }

                <div className='border-top border-blue-gray-200 pt-32 mt-32'>
                    <CustomButtonLoader
                        showLoadingState={isSaveBtnLoading}
                        colorTheme="blue"
                        reverseIconDirection={true}
                        buttonLabel={t("accept_and_continue")}
                        buttonStyle={"py-12 px-3"}
                        handleOnClick={() => {
                            handleSaveCrfConsent();
                        }}
                    />
                </div>
            </div>
        </div>
    )

}

export default ConsentCrfContainer;